<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg2.jpg" alt="" />
    <div class="activity-content">
       <div >充<span>{{materialParamsDTO.materialParamsDetailDTOList[0].rechargeMoney}}</span>多送<span>{{materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMoney}}</span></div>
      <p>共得{{ materialParamsDTO.materialParamsDetailDTOList[0].totalbookCoin}}书币</p>
      <button v-if="status==2" @click="goTopay">立即充值</button>
      <button v-if="status==1" class="default-btn">活动尚未开始</button>
      <button v-if="status==0" class="default-btn">活动已下线</button>
      <button v-if="status==3" class="default-btn">活动已结束</button>
    </div>
    <div class="activity-tip">
      <p>活动规则</p>
       <p>1、活动时间：即日起至<span v-if="endTime">{{endTime}}</span></p>
      <p>2、本次活动
        <span v-if="purchaseLimitDTO.purchaseLimitType==2">参与次数不限</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==1">每天仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==0">每人仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
      </p>
      <p>3、此充值为书币充值，一经充值不支持退款</p>
    </div>
  </div>
</template>
<script>
export default {
  props:['status','materialParamsDTO','endTime','purchaseLimitDTO'],
  data() {
    return {
    };
  },
  watch:{
    materialParamsDTO:{
        handler: function (val) {
         console.log(val)
        },
        deep: true
    },
    purchaseLimitDTO:{
       handler: function (val) {
         console.log(val)
        },
        deep: true
    }
  },
  methods:{
    goTopay(){
     this.$emit('payActivity',this.materialParamsDTO.materialParamsDetailDTOList[0])
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(292px + env(safe-area-inset-top));
  width:100%;
}
.activity-content > div {
  font-size: 30px;
  color: #333333;
  text-align: center;
  font-weight: bold;
}
.activity-content > div > span {
  color: #e31a0b;
}
.activity-content > p {
  text-align: center;
  color: #e31a0b;
  font-size: 18px;
  margin-top: 4px;
  margin-bottom: 36px;
}
.activity-content > button {
  background: #ec2a1c;
  box-shadow: 0 2px 4px 0 rgba(110, 110, 110, 0.5);
  border-radius: 100px;
  font-size: 20px;
  color: #FFFDFA;
  text-align: center;
  line-height: 56px;
  width: 186px;
  height: 56px;
  border: none;
  margin: 0 auto;
  display: block;
}
.activity-content > button.default-btn {
  background: #cfcfcf;
  box-shadow: 0 2px 4px 0 rgba(110, 110, 110, 0.5);
  border-radius: 100px;
  font-size: 20px;
  color: #636363;
}
.activity-tip {
  position: absolute;
  bottom: 59px;
  left: 50%;
  transform: translateX(-50%);
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 14px;
}
.activity-tip p {
   white-space: nowrap;
  font-size: 12px;
  color: #ffffff;
  line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modeltwo.vue